import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltip,
  MatTooltipDefaultOptions
} from '@angular/material/tooltip';

import {DocType} from '../../models/doc-type';
import {DocTypeService} from '../../services/doc-type.service';
import {NGXLogger} from 'ngx-logger';
import {EMPTY, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';
import {isSessionExpired} from '../../models/session-expired-error';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 8000,
  touchendHideDelay: 8000,
};

@Component({
  selector: 'app-doc-type',
  templateUrl: './doc-type.component.html',
  styleUrls: ['./doc-type.component.scss'],
  providers: [
    {provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults}
  ],
})

export class DocTypeComponent implements OnInit {
  public loading: boolean;
  public documents: DocType[] = [];

  constructor(
    public docTypeService: DocTypeService,
    private router: Router,
    private logger: NGXLogger
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.getDocTypes();
  }

  public showTooltip(event: Event, tooltip: MatTooltip): void {
    tooltip?.toggle();
    event.stopPropagation();
  }

  public next(): void {
    this.router.navigate(['/s'], {replaceUrl: true});
  }

  private getDocTypes(): void {
    this.docTypeService.getDocTypes()
      .pipe(
        // The expiry flow takes over; a retry would only go out without a session
        // and hand the gateway's 401 to logger.error, which reports to Sentry.
        catchError((e) => isSessionExpired(e) ? EMPTY : throwError(e)),
        retry(3)
      )
      .subscribe(
        (documents: DocType[]) => {
          this.documents = documents;
          this.loading = false;
        },
        (e) => {
          this.logger.error(e);
          // TODO show message to retry?
        }
      );
  }
}
